import { lazyLoad } from 'utils/loadable';

export const ResetAuthenticator = lazyLoad(
  () => import('./resetAuthenticator.page'),
  (module) => module.ResetAuthenticator
);
